module.exports = __webpack_public_path__ + "img/gmy_business.590a54b8.webp";